// extracted by mini-css-extract-plugin
module.exports = {"addResources":"AddResources_addResources__1mgkg","warning":"AddResources_warning__2U5WI","title":"AddResources_title__kDwm-","roomIcon":"AddResources_roomIcon__2FY8q"};